// TODO: STANDARDIZE_SCAC_CODES
export const SteamShipLines = [
  'MAEU (Maersk Line)',
  'MEDU (Mediterranian Shipping)',
  'YMLU (Yang Ming)',
  'HDMU (Hyundai Merchant Marine)',
  'OOCL (Orient Overseas Container Line)',
  'CMDU (CMA-CGM)',
  'WHLU (Wan Hai Lines)',
  'HLCU (Hapag-Lloyd)',
  'APLU (American President Lines)',
  'ONEY (One Line)',
  'COSU (COSCO Lines)',
  'EGLV (Evergreen)',
  'SUDU (Hamburg Sud)',
  'MAEI (Maersk Line Limited)',
  'SAFM (Saf Marine)',
  'MATS (Matson)',
];

// TODO: STANDARDIZE_SCAC_CODES
export const SteamShipLinesMap = {
  MAEU: 'MAEU (Maersk Line)',
  MEDU: 'MEDU (Mediterranian Shipping)',
  YMLU: 'YMLU (Yang Ming)',
  HDMU: 'HDMU (Hyundai Merchant Marine)',
  OOLU: 'OOLU (Orient Overseas Container Line)',
  CMDU: 'CMDU (CMA-CGM)',
  WHLU: 'WHLU (Wan Hai Lines)',
  HLCU: 'HLCU (Hapag-Lloyd)',
  APLU: 'APLU (American President Lines)',
  ONEY: 'ONEY (One Line)',
  COSU: 'COSU (COSCO Lines)',
  EGLV: 'EGLV (Evergreen)',
  SUDU: 'SUDU (Hamburg Sud)',
  MAEI: 'MAEI (Maersk Line Limited)',
  SAFM: 'SAFM (Saf Marine)',
  MATS: 'MATS (Matson)',
};